// ANIMATE ALL ELEMENTS
//Check if element is in viewport
function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();

  return (
    rect.top + 75 <=
      (window.innerHeight ||
        document.documentElement
          .clientHeight) /* - 20 to start anim bit earlier */ &&
    // rect.left >= 0 &&
    rect.bottom >= 0
    // &&
    // rect.right - 20 <=
    //   (window.innerWidth || document.documentElement.clientWidth)
  );
}
// ANIMATIONS
const noDelay = document.querySelectorAll(".entry-content > *");
//   const delay200 = document.querySelectorAll(
//     ".entry-content p, .entry-content > figure, .wp-block-column:nth-child(2), .blocks-gallery-item:nth-child(2), .entry-content > .wp-block-buttons "
//   );
//   const delay400 = document.querySelectorAll(
//     ".wp-block-column:nth-child(3), .blocks-gallery-item:nth-child(3) "
//   );
//   const delay600 = document.querySelectorAll(
//     ".wp-block-column:nth-child(4), .blocks-gallery-item:nth-child(3) ~ .blocks-gallery-item "
//   );

const toAnimate = () => {
  noDelay.forEach((el) => {
    el.classList.add("toanimate");
  });
  // delay200.forEach((el) => {
  //   el.classList.add("toanimate");
  // });
  // delay400.forEach((el) => {
  //   el.classList.add("toanimate");
  // });
  // delay600.forEach((el) => {
  //   el.classList.add("toanimate");
  // });
};
toAnimate();

const handler = () => {
  noDelay.forEach((element) => {
    if (isElementInViewport(element)) {
      //   element.classList.add("animated", "fadeIn"); //for animate sass
      element.classList.add("animate__animated", "animate__fadeIn"); //for animate css v4
    }
  });
  //   delay200.forEach((element) => {
  //     if (isElementInViewport(element)) {
  //       element.classList.add("animated", "fadeIn", "delay-200");
  //     }
  //   });
  //   delay400.forEach((element) => {
  //     if (isElementInViewport(element)) {
  //       element.classList.add("animated", "fadeIn", "delay-400");
  //     }
  //   });
  //   delay600.forEach((element) => {
  //     if (isElementInViewport(element)) {
  //       element.classList.add("animated", "fadeIn", "delay-600");
  //     }
  //   });
};

if (window.addEventListener) {
  addEventListener("DOMContentLoaded", handler, false);
  addEventListener("load", handler, false);
  addEventListener("scroll", handler, { passive: true });
}
